import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import ListTable from "@/modules/list-table";
import { TABLE_FILTER_TEXT } from "@/modules/table-filter";

const OrganizationsTable = (listTableProps) => {
  const { t } = useTranslation();

  const columns = [
    {
      width: "80%",
      title: t("global:name"),
      dataIndex: "name",
      render: (name, { id }) => <Link to={`/organizations/${id}`}>{name}</Link>,
      sorter: true,
      ...TABLE_FILTER_TEXT,
    },
    {
      width: "10%",
      title: t("global:locationPlural"),
      dataIndex: "locations_count",
      sorter: true,
    },
    {
      width: "10%",
      title: t("global:assetPlural"),
      dataIndex: "assets_count",
      sorter: true,
    },
  ];

  return (
    <ListTable modelKey="organization" columns={columns} {...listTableProps} />
  );
};

export default OrganizationsTable;
